import { useState } from "react";
import { IconButton, Modal } from "src/Components";
import { Input } from "src/Components/Controls";
import { SelectBox } from "src/UI";
import { IModalProps } from "..";
import "./ReturnTransferModal.scss";

const OTHER_REASON = "other";

const transferReasons: Array<{ id: string; title: string }> = [
	{ id: "other-window-service", title: "Требуется обслуживание в другом окне" },
	{ id: "specialist-competence", title: "Перенаправление по компетенции специалиста" },
	{ id: OTHER_REASON, title: "Другая причина" }
];

const ReturnTransferModal: React.FC<IModalProps> = ({ isOpen, onClose, onAction }) => {
	const [ reason, setReason ] = useState<string>("");
	const [ otherReason, setOtherReason ] = useState<string>("");
	const [ comment, setComment ] = useState<string>("");
	const isOtherReason = reason === OTHER_REASON;
	const selectedReason = transferReasons.find(item => item.id === reason)?.title || "";
	const resolvedReason = isOtherReason ? otherReason.trim() : selectedReason;
	const isInvalid = !resolvedReason;

	const handleReasonChange = (value: string) => {
		setReason(value);
		if (value !== OTHER_REASON) setOtherReason("");
	};

	const onConfirm = () => {
		if (isInvalid) return;
		onAction("return-redirect-confirm", {
			reason: resolvedReason,
			comment: comment.trim()
		});
	};

	const renderBody: React.FC = () => (
		<div className="return-transfer-modal__body">
			<label className="return-transfer-modal__label">
				Причина перенаправления посетителя <span>*</span>
			</label>
			<SelectBox
				options={transferReasons}
				selectedValues={reason ? [reason] : []}
				onChangeSelected={(items) => handleReasonChange(items[0]?.id ?? "")}
				placeholder="Выберите причину из списка"
				allowClear
			/>
			{isOtherReason && (
				<>
					<label className="return-transfer-modal__label">
						Другая причина перенаправления <span>*</span>
					</label>
					<Input
						value={otherReason}
						onChangeValue={setOtherReason}
						className="return-transfer-modal__input"
					/>
				</>
			)}
			<label className="return-transfer-modal__label">Комментарий к посетителю</label>
			<Input
				type="textarea"
				value={comment}
				onChangeValue={setComment}
				className="return-transfer-modal__comment"
			/>
		</div>
	);

	return (
		<Modal
			isOpen={isOpen}
			title="Перенаправление в другое окно"
			titleType="small"
			onClose={onClose}
			color="light"
			className="return-transfer-modal"
			renderBody={renderBody}
			renderFooter={(
				<>
					<IconButton color="red" outline onClick={onClose}>Отмена</IconButton>
					<IconButton color="green" disable={isInvalid} onClick={onConfirm}>
						Перенаправить
					</IconButton>
				</>
			)}
		/>
	);
};

export default ReturnTransferModal;
